/**
 * @private-doc
 */
export type ACLPermissionValues = 1 | 2 | 4 | 8 | 16
export class ACLPermission {
  public static readonly VIEW: ACLPermissionValues = 1
  public static readonly CREATE: ACLPermissionValues = 2
  public static readonly EDIT: ACLPermissionValues = 4
  public static readonly DELETE: ACLPermissionValues = 8
  public static readonly UNDELETE: ACLPermissionValues = 16
}
